module.exports = __webpack_public_path__ + "static/media/benefits-ic-01.7d8a28f8.svg";